export const normalizeRouteTemplate = (routeTemplate: string): string => {
  const normalized = routeTemplate.replace(/[/?]+$/, "");
  return normalized || "/";
};
